// extracted by mini-css-extract-plugin
export default {"detail":"Detail-module__detail__dmt5b"};